import { render, staticRenderFns } from "./brakeDetail.vue?vue&type=template&id=31c1c6ba&scoped=true&"
import script from "./brakeDetail.vue?vue&type=script&lang=js&"
export * from "./brakeDetail.vue?vue&type=script&lang=js&"
import style0 from "./brakeDetail.vue?vue&type=style&index=0&id=31c1c6ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c1c6ba",
  null
  
)

export default component.exports